<template>
  <v-container
    fluid
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-domain
      </v-icon> Organization
    </h2>
    <v-card
      color="#CFD8DC"
    >
      <v-container
        fluid
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-card
              color="#eceff1"
            >
              <v-card-title class="justify-center">
                <h3
                  class="my-2"
                  style="color:#37474F"
                >
                  Organization Details
                </h3>
              </v-card-title>
              <v-container
                fluid
              >
                <p class="my-p-style">
                  Name:-
                  <font class="font-my-style">
                    {{ organizationDetails.name }}
                  </font>
                </p>
                <p class="my-p-style">
                  Alias:-
                  <font class="font-my-style">
                    {{ organizationDetails.alias }}
                  </font>
                </p>
                <p class="my-p-style">
                  Type:-
                  <font class="font-my-style">
                    {{ organizationDetails.type }}
                  </font>
                </p>
                <p class="my-p-style">
                  Category:-
                  <font class="font-my-style">
                    {{ organizationDetails.category }}
                  </font>
                </p>
                <p
                  v-if="!isAddressAvailable"
                  class="my-p-style"
                >
                  Address:-
                  <font class="font-my-style">
                    N/A
                  </font>
                </p>
                <div
                  v-if="isAddressAvailable"
                  class="my-p-style"
                >
                  <p class="my-p-style">
                    Address:-
                  </p>
                  <v-container class="ml-2 py-0">
                    <p class="address-style">
                      Street 1:- <font class="address-font-style">
                        {{ organizationDetails.address.line1 }}
                      </font>
                    </p>
                    <p class="address-style">
                      Street 2:- <font
                        v-if="organizationDetails.address.line2 !== null"
                        class="address-font-style"
                      >
                        {{ organizationDetails.address.line2 }}
                      </font>
                      <font
                        v-else
                        class="address-font-style"
                      >
                        N/A
                      </font>
                    </p>
                    <p class="address-style">
                      City:- <font class="address-font-style">
                        {{ organizationDetails.address.city }}
                      </font>
                    </p>
                    <p class="address-style">
                      State:- <font class="address-font-style">
                        {{ organizationDetails.address.state }}
                      </font>
                    </p>
                    <p class="address-style">
                      Country:- <font class="address-font-style">
                        {{ organizationDetails.address.country }}
                      </font>
                    </p>
                    <p class="address-style">
                      Postal Code:- <font class="address-font-style">
                        {{ organizationDetails.address.postal_code }}
                      </font>
                    </p>
                  </v-container>
                </div>
                <p class="my-p-style">
                  Phone Number:-
                  <font
                    v-if="organizationDetails.phone_number !== null"
                    class="font-my-style"
                  >
                    {{ organizationDetails.phone_number }}
                  </font>
                  <font
                    v-else
                    class="font-my-style"
                  >
                    N/A
                  </font>
                </p>
                <p class="my-p-style">
                  External Id:-
                  <font class="font-my-style">
                    {{ organizationDetails.external_id }}
                  </font>
                </p>
                <p class="my-p-style">
                  Created At:-
                  <font class="font-my-style">
                    {{ organizationDetails.created_at | convertStringToLocalDatetime }}
                  </font>
                </p>
                <p class="my-p-style">
                  Office Timezone:-
                  <font class="font-my-style">
                    {{ organizationDetails.office_timezone }}
                  </font>
                </p>
              </v-container>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-card
              color="#eceff1"
            >
              <v-card-title class="justify-center">
                <h3
                  class="my-2"
                  style="color:#37474F"
                >
                  Subscription Details
                </h3>
              </v-card-title>
              <v-container
                fluid
              >
                <p class="my-p-style">
                  Product Type:-
                  <font class="font-my-style">
                    BannerEx
                  </font>
                </p>
                <p class="my-p-style">
                  Version:-
                  <font class="font-my-style">
                    Advanced
                  </font>
                </p>
                <p class="my-p-style">
                  Status:-
                  <font
                    v-if="organizationDetails.subscription_status !== null"
                    class="my-status-style"
                    :color="getColor(organizationDetails.subscription_status)"
                  >
                    {{ organizationDetails.subscription_status | statusUpdate }}
                  </font>
                  <font
                    v-else
                    class="my-status-style"
                  >
                    N/A
                  </font>
                </p>
              </v-container>
            </v-card>
          </v-col>
          <centre-spinner
            :loading="loading"
          />
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import moment from 'moment';

  export default {
    name: 'OrganizationDetails',
    components: {
      'centre-spinner': spinner,
    },
    filters: {
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      statusUpdate (status) {
        if (status === 'active') {
          return 'Active*';
        } else if (status === 'trial') {
          return 'Trial*';
        } else if (status === 'grace_period') {
          return 'Grace Period';
        } else {
          return 'Expired';
        }
      },
    },
    data () {
      return {
        loading: false,
        isAddressAvailable: false,
      };
    },
    computed: {
      organizationDetails () {
        return this.$store.getters['organizations/getOrganizationDetails'];
      },
    },
    async mounted () {
      this.loading = true;
      await this.fetchOrganizationDetails();
      this.loading = false;
    },
    methods: {
      async fetchOrganizationDetails () {
        const organizationlId = this.$route.params.organizationId;
        await this.$store.dispatch('organizations/fetchOrganizationDetails', {
          organizationId: organizationlId,
        }).then(response => {
          if (this.organizationDetails.address !== null) {
            this.isAddressAvailable = true;
          } else {
            this.isAddressAvailable = false;
          };
        });
      },
      getColor (status) {
        if (status === 'active') return '#2E7D32';
        else if (status === 'expired') return '#C62828'; else return '#EF6C00';
      },
    },
  };
</script>
<style scoped>
.font-my-style {
  font-weight: bold;
  font-size: 15px;
  color: #37474F;
}
.my-p-style {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  margin-bottom: 5px;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.address-style {
margin-bottom: 5px;
color: #546E7A;
}
.address-font-style {
  color: #37474F;
}
.my-status-style {
  font-weight: bold;
  font-size: 15px;
}
@media (max-width: 960px) {
  .title-style {
   margin-top: -20px;
  }
}
</style>
